var Addresses = (function (CheckoutApiCollection, Address, PickupPoint) {
	return CheckoutApiCollection.extend({
		model: Address,

		initialize: function () {
			this.fetch();
		},

		fetch: function () {
			return this._api.getUserAddresses()
                      .done(_.bind(this._success, this));
		},

		isActive: function () {
			return this._isActive;
		},

		setActive: function (isActive) {
			this._isActive = isActive;
			this.trigger('isActive', isActive);
		},

		isValid: function () {
			this.trigger('isValid', false);
			return false;
		},

		_success: function (data) {
			var addresses = []; //tbd: use where
			_.each(data.Value.AddressesList, function (address) {
				if (address.ID && address.ID !== '00000000-0000-0000-0000-000000000000') {
					try {
                        var pickup = JSON.parse(address.AdditionalData || null) || {};
					} catch (e) {
						window.NREUM && _.isFunction(window.NREUM.noticeError) && window.NREUM.noticeError(e);
						pickup = {};
					}
					address.pickupPoint = new PickupPoint(pickup);
					addresses.push(address);
				}
			});
			this.update(addresses);
		}
	});
})(CheckoutApiCollection, Address, PickupPoint);
